export const GET_EMPLOYEES = "GET_EMPLOYEES"
export const GET_EMPLOYEES_LOADING = "GET_EMPLOYEES_LOADING"
export const GET_EMPLOYEES_SUCCESS = "GET_EMPLOYEES_SUCCESS"
export const GET_EMPLOYEES_ERROR = "GET_EMPLOYEES_ERROR"

export const SET_SELECTED_EMPLOYEE = 'SET_SELECTED_EMPLOYEE'

export const setSelectedEmployee = (selectedEmployee) => ({ type: SET_SELECTED_EMPLOYEE, data: selectedEmployee })
export const getEmployees = (body) => ({ type: GET_EMPLOYEES, body })